import { AmountType } from '@shared/cards-types';

export const creditShared = {
    layout: {
        productInfo: {
            showBalanceAndOutstandingAmount: false,
            showOutstandingAndBalanceAmount: false,
            showBalanceAndAvailableCreditAmount: false,
            showBalanceAndPositiveOutstandingAmount: false,
            showOwner: false,
            showCurrentCycleTurnover: false,
        },
    },
    overview: {
        showOutstandingWithDueDate: false,
        showBalanceWithLimitInfo: false,
        showOwner: false,
    },
    menu: {
        supplementary: {
            enabled: false,
            _description: 'Enables supplementary cards menu item in the credit card side menu',
        },
        newTransfer: {
            enabled: false,
            _description: 'Enables new transfer menu item in the credit card side menu',
        },
    },
    invoices: {
        showNewInvoicesDeliveryView: {
            enabled: false,
            _description: 'Enables the newly refactored Statements Delivery',
        },
        oldEndPoint: false,
    },
    reservations: {
        description: false,
        hideDescriptionText: false,
        useCardIdEnabled: false,
        typeForAllReservations: 'MAIN',
        amountSender: false,
        info: false,
        status: false,
        type: false,
        validFromTo: {
            enabled: false,
            _description: `
                    Controls whether to show "valid from" and "valid to" fields
                    when showing Credit Card Reservations.
                `,
        },
        exchangeRate: false,
        expirationDate: false,
    },
    preferOutstandingAmount: false,
    supplementary: {
        enabled: false,
        autoForward: false,
        allowHiddenCardImage: false,
    },
    functions: {
        tpLimits: {
            enabled: false,
            editor: {
                confirmationEnabled: false,
                confirmationLanguages: [] as string[],
                limitTypes: [] as string[],
                showMaxLimitHelp: false,
            },
            limitValues: {
                atm: [] as number[],
                internet: [] as number[],
                pos: [] as number[],
            },
            doubleFetchEnabled: false,
            doubleFetchTimeout: 0,
            validations: {
                ATM: {
                    divisible: {
                        _description: 'Enables ATM limit divisible validation rule',
                        enabled: false,
                    },
                },
                POS: {
                    divisible: {
                        _description: 'Enables POS limit divisible validation rule',
                        enabled: false,
                    },
                },
                INTERNET: {
                    divisible: {
                        _description: 'Enables INTERNET limit divisible validation rule',
                        enabled: false,
                    },
                    biggerAsPOS: {
                        _description: 'Enables INTERNET limit biggerAsPOS validation rule',
                        enabled: false,
                    },
                },
                TOTAL: {
                    biggerAsAll: {
                        _description: 'Enables TOTAL limit biggerAsAll validation rule',
                        enabled: false,
                    },
                },
            },
            types: [] as string[],
            temporaryLimitDaysMode: false,
        },
        payUp: {
            noFlagNeeded: false,
            receiverNeeded: false,
            idField: '',
            ibanField: 'iban',
            bicField: 'bic',
            requireSameCurrency: true,
            allowAmountHigherThenBalance: false,
            validAccounts: {
                domesticOrOwnTransferAllowed: false,
                currentAndSavingsAccounts: false,
            },
            showPaidAmounts: false,
            hideMinimalMonthlyAmount: false,
            suggestionAmounts: [
                AmountType.DRAWN_AMOUNT,
                AmountType.LAST_OWED_AMOUNT,
                AmountType.MINIMAL_MONTHLY_AMOUNT,
                AmountType.OVER_DUE_AMOUNT,
            ],
        },
    },
    smallInfoBox: {
        hideInactiveBalance: false,
    },
    settings: {
        displayIBAN: false,
        /* Display credit cards in the Customize George page */
        allowPersonalization: true,
        productWhitelist: [] as string[],
    },
    showAuthorizedAsSubCard: false,
};
